<div *ngIf="edit || !hide" [ngClass]="{ disabled: hide }" data-testid="toggled-item">
  <ng-content></ng-content>
</div>
